import { useSocket } from "../../context/SocketContext";

import { DirectionsRenderer, GoogleMap } from "@react-google-maps/api";
// import { useSocket } from "Context/SocketContext";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  TRIP_ROUTE_TYPE,
  TRIP_STOP_IMAGES,
  TRIP_STOP_TYPE,
  ROUTE_STOP_STATUS,
  TRIP_STATUS,
} from "../../Helper";
import { setBusSpeed } from "../../Data/features/socket";

const MapDirection = ({
  trip_type = "",
  vehicle_location = null,
  origin,
  destination,
  waypoints = [],
  hasMarker = false,
  option = {},
  className = "",
  zoom = 9,
}) => {
  const isSocketConnected = useSelector((state) => state.socket.isConnected);
  const socket = useSocket();
  const dispatch = useDispatch();

  console.log(isSocketConnected);

  const mapRef = useRef(null);
  const [direction, setDirection] = useState(null);
  const options = useMemo(
    () => ({
      mapId: "17c975ad78fa8a12",
      disableDefaultUI: true,
      clickableIcons: false,
      gestureHandling: "auto",
      draggable: true,
      scaleControl: true,
      zoomControl: true,
      ...option,
    }),
    []
  );

  const markersDataRef = useRef([origin, ...waypoints, destination]);
  const markersRef = useRef(null);
  const vehicleMarkerRef = useRef(null);
  // const serviceMarkerRef = useRef([]);
  // const stopMarkerRef = useRef([]);

  useEffect(() => {
    if (hasMarker && isSocketConnected) {
      socket.on("trip_location_updated", (data) => {
        // console.log("trip_location_updated", data);
        vehicleMarkerRef.current.setPosition(
          new window.google.maps.LatLng(data.latitude, data.longitude)
        );
        dispatch(setBusSpeed(data.speed));
      });
    }

    return () => {
      socket?.dispose("trip_location_updated");
    };
  }, [isSocketConnected, mapRef.current]);

  useEffect(() => {
    if (!mapRef.current) return;

    // Add custom  markers
    if (!!vehicle_location) {
      vehicleMarkerRef.current = new window.google.maps.Marker({
        position: new window.google.maps.LatLng(
          vehicle_location?.latitude,
          vehicle_location?.longitude
        ),
        map: mapRef.current,
        icon: {
          url: TRIP_STOP_IMAGES["vehicle"], // Replace with your custom icon path
          scaledSize: new window.google.maps.Size(80, 80), // Adjust size as needed
          anchor: new window.google.maps.Point(20, 20), // Adjust anchor to center
        },
      });
    }

    const directions = [origin, ...waypoints, destination];
    markersRef.current = directions.map((item, index) => {
      if (markersRef?.current) {
        // Remove old markers if they exist
        markersRef.current[index].setMap(null);
      }

      if (
        (index === 0 && trip_type === TRIP_ROUTE_TYPE.DROP_OFF) ||
        (index === directions.length - 1 &&
          trip_type === TRIP_ROUTE_TYPE.PICKUP)
      ) {
        return new window.google.maps.Marker({
          position: new window.google.maps.LatLng(item.lat, item.lng),
          map: mapRef.current,
          icon: {
            url: TRIP_STOP_IMAGES["home"],
            scaledSize: new window.google.maps.Size(60, 60),
          },
        });
      } else {
        return new window.google.maps.Marker({
          position: new window.google.maps.LatLng(item.lat, item.lng),
          map: mapRef.current,
          icon: {
            url:
              item?.type === TRIP_STOP_TYPE.EMERGENCY
                ? TRIP_STOP_IMAGES["red"]
                : item.status === TRIP_STATUS.COMPLETED
                ? TRIP_STOP_IMAGES["green"]
                : TRIP_STOP_IMAGES["blue"],
            scaledSize: new window.google.maps.Size(30, 40),
          },
          label: {
            text: `${index + 1}`, // D for Destination
            color: "white",
            fontSize: "15px",
            fontWeight: "bold",
            className: "mb-2",
          },
        });
      }
    });

    return () => {
      if (markersRef.current) {
        markersRef.current?.forEach((item) => item?.setMap(null));
        vehicleMarkerRef.current?.setMap(null);
      }
    };
  }, [mapRef.current, origin, destination, waypoints]);

  const onLoad = useCallback((map) => {
    mapRef.current = map;

    const directionsService = new window.google.maps.DirectionsService();
    const travelMode = window.google.maps.TravelMode.DRIVING;
    directionsService.route(
      {
        origin,
        destination,
        travelMode,
        waypoints: waypoints?.map((item) => ({
          location: { lat: item?.lat, lng: item?.lng },
          stopover: true,
        })),
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          setDirection(result);
        } else {
          console.error("Directions request failed due to " + status);
        }
      }
    );
  }, []);

  function getDefaultMarker(lat, lng, icon = TRIP_STOP_IMAGES["default"]) {
    return new window.google.maps.Marker({
      position: new window.google.maps.LatLng(lat, lng),
      map: mapRef.current,
      icon: {
        url: icon, // Replace with your custom icon path
        scaledSize: new window.google.maps.Size(20, 30), // Adjust size as needed
        anchor: new window.google.maps.Point(20, 20), // Adjust anchor to center
      },
    });
  }

  function updateMarkerStatus(stop_id, status) {
    markersDataRef.current.forEach((item, index) => {
      if (!markersRef?.current || item.id != stop_id) return;

      markersRef.current[index].setMap(null);
      markersDataRef.current[index].status = status;

      new window.google.maps.Marker({
        position: new window.google.maps.LatLng(item.lat, item.lng),
        map: mapRef.current,
        icon: {
          url: TRIP_STOP_IMAGES[status]
            ? TRIP_STOP_IMAGES[status]
            : TRIP_STOP_IMAGES["default"],
          scaledSize: new window.google.maps.Size(30, 40),
        },
        label: {
          text: `${index + 1}`, // D for Destination
          color: "white",
          fontSize: "15px",
          fontWeight: "bold",
          className: "mb-2",
        },
      });

      return;
    });
  }

  return (
    <div className="w-100 h-100 d-flex flex-column">
      <GoogleMap
        key={"direction-map"}
        zoom={zoom}
        center={origin}
        mapContainerClassName={`window.googleMap ${className}`}
        options={options}
        onLoad={onLoad}
        mapContainerStyle={{ width: "100%", height: "100%" }}
      >
        {direction && (
          <DirectionsRenderer
            options={{
              directions: direction,
              draggable: false,
              suppressMarkers: true,
            }}
          />
        )}
      </GoogleMap>
    </div>
  );
};

export default React.memo(MapDirection);
